import React from 'react';

const Logout = () => {
    return (
        <svg width={24} height={20} viewBox="0 0 24 20">
            <defs>
                <style>
                    {
                        '.prefix__a{fill:none;stroke:#8f99dc;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}'
                    }
                </style>
            </defs>
            <g transform="translate(0 -2)">
                <path
                    className="prefix__a"
                    d="M16 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"
                />
                <circle
                    className="prefix__a"
                    cx={4}
                    cy={4}
                    r={4}
                    transform="translate(4.5 3)"
                />
                <path className="prefix__a" d="M23 11h-6" />
            </g>
        </svg>
    );
};

export default Logout;
